import { render, staticRenderFns } from "./GnbSiteMap.vue?vue&type=template&id=874cdbe0"
import script from "./GnbSiteMap.ts?vue&type=script&lang=js&external"
export * from "./GnbSiteMap.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports